<template>
    <div>
        <label>{{label}}</label>
        <ckeditor
                :editor="editor"
                :value="value"
                @input="handleInput"
                @ready="onReady"
                :config="editorConfig"
        />
    </div>
</template>

<script>
    import Editor from './ckeditor/ckeeditor'

    export default {
        name: "TxCkeEditor",
        props: {
            value: {
                default: ''
            },
            label: {
                default: ''
            },
        },
        data() {
            return {
                editor: Editor,
                editorConfig: {
                    toolbar: ['bold', 'italic'],
                }
            }
        },
        methods: {
            handleInput(value) {
                this.$emit('input', value)
            },
            onReady(editor) {
                editor.ui.getEditableElement().parentElement.insertBefore(
                    editor.ui.view.toolbar.element,
                    editor.ui.getEditableElement()
                );
                this.$emit('ready', editor);
                setTimeout(()=>{
                    editor.setData(this.value)
                },10)
            },
        }
    }
</script>

<style scoped>

</style>